export interface Category {
  id: string;
  nameKey: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { id: 'shoes', nameKey: 'categories.shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { id: 'hoodies', nameKey: 'categories.hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { id: 'tshirts', nameKey: 'categories.tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { id: 'jackets', nameKey: 'categories.jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { id: 'pants', nameKey: 'categories.pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { id: 'headwear', nameKey: 'categories.headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-shield-star-line' },
  { id: 'sets', nameKey: 'categories.sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { id: 'underwear', nameKey: 'categories.underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-archive-line' },
  { id: 'jersey', nameKey: 'categories.jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-flag-line' },
  { id: 'accessories', nameKey: 'categories.accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-sparkling-line' },
  { id: 'bags', nameKey: 'categories.bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { id: 'belts', nameKey: 'categories.belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-loop-right-line' },
  { id: 'perfumes', nameKey: 'categories.perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { id: 'other', nameKey: 'categories.other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-2-line' },
];

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const SUPPORTED_LANGS = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'pl', label: 'Polski', short: 'PL' },
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'fr', label: 'Français', short: 'FR' },
];